import mitt from "mitt";
import { FC, PropsWithChildren } from "react";

import { useLandingsAuth } from "../../hooks";
import { GlobalLandingsAppEvents } from "../../models";
import {
  CompanyScopeLandingsContext,
  ICompanyScopeLandingsContext,
} from "./company-scope-landings.context";

interface ICompanyScopeLandingsContextWrapperProps extends PropsWithChildren {
  companyId: number;
  isDynamicLandingPage?: boolean;
}

export const CompanyScopeLandingsContextWrapper: FC<
  ICompanyScopeLandingsContextWrapperProps
> = ({ children, companyId, isDynamicLandingPage = false }) => {
  const { isLoggedIn } = useLandingsAuth();
  const eventEmitter = mitt<GlobalLandingsAppEvents>();

  const contextData: ICompanyScopeLandingsContext = {
    auth: { isLoggedIn },
    isDynamicLandingPage,
    companyId,
    eventEmitter,
  };
  return (
    <CompanyScopeLandingsContext.Provider value={contextData}>
      {children}
    </CompanyScopeLandingsContext.Provider>
  );
};
